export default "assets/images/icons/instagram2-178dba44.svg";